export const COURSE_TYPES = Object.freeze({
  DEGREE: 'Degree',
  PG: 'P.G.',
  INTER: 'Inter',
  SCHOOL: 'School',
});

export const COURSE_TYPE_OPTIONS = [
  { value: COURSE_TYPES.DEGREE, label: 'Degree' },
  { value: COURSE_TYPES.PG, label: 'P.G.' },
  { value: COURSE_TYPES.INTER, label: 'Inter' },
  { value: COURSE_TYPES.SCHOOL, label: 'School' },
];

const schoolNames = new Set([
  'NUR', 'LKG', 'UKG',
  '1ST', '2ND', '3RD', '4TH', '5TH',
  '6TH', '7TH', '8TH', '9TH', '10TH',
]);
const interNames = new Set(['MPC', 'BPC', 'CEC', 'MEC']);

export const classifyCourseType = (branch) => {
  if (Object.values(COURSE_TYPES).includes(branch?.course_type)) return branch.course_type;
  const name = String(branch?.baseLabel || branch?.branch_name || branch?.label || '').trim().toUpperCase();
  if (schoolNames.has(name)) return COURSE_TYPES.SCHOOL;
  if (interNames.has(name)) return COURSE_TYPES.INTER;
  if (name.includes('PG')) return COURSE_TYPES.PG;
  return COURSE_TYPES.DEGREE;
};

export const sessionLength = (label) => {
  const years = String(label || '').match(/\d{4}/g) || [];
  if (years.length < 2) return null;
  const length = Number(years[1]) - Number(years[0]);
  return Number.isFinite(length) && length > 0 ? length : null;
};

export const amountText = (value) => (value === null || value === undefined ? '' : String(value));

export const validAmount = (value) => /^\d+(?:\.\d{1,2})?$/.test(String(value || '').trim());

export const formatMoney = (value) => new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: Number(value) % 1 ? 2 : 0,
  maximumFractionDigits: 2,
}).format(Number(value || 0));
